import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const Y_OFFSET = 100;

const hidden = buildHiddenVariant({ y: Y_OFFSET });
const visible = buildVisibleVariant();

/*
 * Footer Animations
 */

export const footerMotionProperties: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden,
    visible,
  },
  viewport: { once: true },
  whileInView: 'visible',
};
